import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, MessageCircle, MapPin, CalendarPlus, Mail, Plus, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { CLINIC } from "@/data/site";
import { trackEvent } from "@/lib/analytics";
import { triggerLink } from "@/lib/actions";

const actions = [
  { key: "call", label: "Call", Icon: Phone, href: CLINIC.phoneHref, color: "#0F5C5A", event: "call_click", external: false },
  { key: "whatsapp", label: "WhatsApp", Icon: MessageCircle, href: CLINIC.whatsappHref, color: "#25D366", event: "whatsapp_click", external: true },
  { key: "directions", label: "Directions", Icon: MapPin, href: CLINIC.directionsUrl, color: "#C8A86B", event: "directions_click", external: true },
  { key: "email", label: "Email", Icon: Mail, href: CLINIC.emailHref, color: "#0B4443", event: "email_click", external: false },
];

export const FloatingActions = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handle = (a) => {
    trackEvent(a.event, { location: "floating" });
    triggerLink(a.href, a.external);
    setOpen(false);
  };

  return (
    <div data-testid="floating-actions" className="fixed z-40 right-4 bottom-24 sm:bottom-28 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }} className="flex flex-col items-end gap-3">
            <button onClick={() => { trackEvent("appointment_cta_click", { location: "floating" }); navigate("/appointment"); setOpen(false); }} data-testid="floating-appointment" className="group flex items-center gap-2">
              <span className="text-xs bg-white shadow-[var(--cdt-shadow-sm)] px-2.5 py-1 rounded-full border border-[color:var(--cdt-border)]">Appointment</span>
              <span className="h-12 w-12 rounded-full flex items-center justify-center text-white shadow-lg" style={{ background: "#0F5C5A" }}><CalendarPlus className="h-5 w-5" /></span>
            </button>
            {actions.map((a) => (
              <button key={a.key} onClick={() => handle(a)} data-testid={`floating-${a.key}`} className="group flex items-center gap-2">
                <span className="text-xs bg-white shadow-[var(--cdt-shadow-sm)] px-2.5 py-1 rounded-full border border-[color:var(--cdt-border)]">{a.label}</span>
                <span className="h-12 w-12 rounded-full flex items-center justify-center text-white shadow-lg" style={{ background: a.color }}><a.Icon className="h-5 w-5" /></span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <button
        data-testid="floating-actions-toggle"
        onClick={() => setOpen((v) => !v)}
        className="h-14 w-14 rounded-full bg-[var(--cdt-primary)] text-white shadow-xl flex items-center justify-center hover:bg-[var(--cdt-primary-2)] transition-colors"
        aria-label="Quick actions"
      >
        {open ? <X className="h-6 w-6" /> : <Plus className="h-6 w-6" />}
      </button>
    </div>
  );
};
